import React from "react";
import { Link } from "react-router-dom";

/**
 * SectionLayout — shared shell for every sub-page.
 * Renders the same W1 background scene + PANDURATA wordmark, but
 * hides all curved nav labels. Children render inside a centered
 * glass panel.
 */
const SectionLayout = ({ children }) => {
  return (
    <main className="home" data-testid="section-page">
      <div className="home__scene" data-testid="home-scene">
        <Link
          to="/"
          className="home__wordmark home__wordmark--link"
          data-testid="wordmark-pandurata"
          aria-label="Return to Pandurata home"
        >
          PANDURATA
        </Link>
        <div className="glass-panel" data-testid="glass-panel">
          {children}
        </div>
      </div>
      <div className="home__mark" data-testid="footer-mark">
        EST · BOTANY MEETS BRUTALISM
      </div>
    </main>
  );
};

export default SectionLayout;
